import { MatSnackBar } from '@angular/material/snack-bar';
import { showSnackBar } from './snackBar.ulti';
import { TranslateService } from '@ngx-translate/core';

type ExtractErrorsParams = {
  status: number;
  snackBar: MatSnackBar;
  translate: TranslateService;
};

export const extractErrors = ({ status, snackBar, translate }: ExtractErrorsParams): void => {
  const internalNotiMessage = 'An error occurred on the server. Please try again later or contact support.';
  const notFoundNotiMessage = 'The requested resource was not found.';

  switch (true) {
    case status === 500:
      showSnackBar({ type: 'error', message: internalNotiMessage, snackBar, translate });
      break;

    case status === 404:
      showSnackBar({ type: 'error', message: notFoundNotiMessage, snackBar, translate });
      break;

    default:
      break;
  }
};
